@use '../@shared/mixins' as *;
@use '../@shared/global' as *;

@layer kol-component {
	.kol-kolibri {
		display: inline-block;
		max-height: 100%;

		&__text {
			font-size: to-rem(90);
			letter-spacing: normal;
			word-spacing: normal;
		}
	}
}
